import ReactPDF, { Image, Text, View } from "@react-pdf/renderer";
import { styles } from "../GenericPdf/style";
import { formatDate } from "../../../../utils/commonFunctions";
import { renderDocumentType } from "../../../../utils/invoiceGeneration/commonFunctions";

type AppProps = {
  downloadRevenuesData: any;
  isFixed: boolean;
};

let blobBaseUrl = process.env.REACT_APP_BLOB_BASE_URL;
let blobToken = process.env.REACT_APP_BLOB_TOEKN;

const PurchaseOrderBillFromAndLogo = ({ downloadRevenuesData, isFixed }: AppProps) => {

  return (
    <View {...(isFixed ? { fixed: true } : {})}>
      {/* first column  */}
      <View style={styles.sub_header_1}>
        <View style={{ maxWidth: "40%" }}>
          {!!downloadRevenuesData?.primary_details?.logo_details?.file_url
            ?.length ? (
            <Image
              style={styles.image}
              src={`${blobBaseUrl}${downloadRevenuesData?.primary_details?.logo_details?.file_url}?${blobToken}`}
            />
          ) : null}
        </View>

        {downloadRevenuesData?.primary_details?.document_type?.label ? (
          <View style={{ maxWidth: "50%" }}>
            <Text style={styles.heading}>
              {downloadRevenuesData?.primary_details?.document_type?.label}
            </Text>
          </View>
        ) : null}
      </View>

      {/* second column  */}
      <View style={{ ...styles.sub_header_1 }}>
        <View
          style={{
            // alignItems: "flex-start",
            maxWidth: "35%",
          }}
        >
          <Text
            style={{
              ...styles.sub_header,
              textAlign: "left",
              color: "#dd4433",
            }}
          >
            Branch :{" "}
          </Text>

          {downloadRevenuesData?.primary_details?.branch?.trade_name ? (
            <Text style={{ ...styles.text, paddingVertical: "2px" }}>
              {downloadRevenuesData?.primary_details?.branch?.trade_name}
            </Text>
          ) : null}
          {downloadRevenuesData?.primary_details?.branch_address1 ||
            downloadRevenuesData?.primary_details?.branch_address2 ? (
            <Text style={styles.text}>
              {downloadRevenuesData?.primary_details?.branch_address1}
              {" "}
              {downloadRevenuesData?.primary_details?.branch_address2 ? downloadRevenuesData?.primary_details?.branch_address2 : ""}
            </Text>
          ) : null}
          {downloadRevenuesData?.primary_details?.cin_number ? (
            <View style={styles.flexCenter}>
              <Text style={styles.sub_header}>CIN No : </Text>
              <Text style={styles.text}>
                {downloadRevenuesData?.primary_details?.cin_number}
              </Text>
            </View>
          ) : null}
          <View
          // style={{
          //   alignItems: "flex-start",
          //   maxWidth: "40%",
          //   // marginTop: "-15px",
          //   borderTop: "1px solid red",
          // }}
          >
            {downloadRevenuesData?.primary_details?.business_address_details
              ?.pan_number ? (
              <View style={styles.flexCenter}>
                <Text style={styles.sub_header}>PAN No : </Text>

                <Text style={styles.text}>
                  {
                    downloadRevenuesData?.primary_details
                      ?.business_address_details?.pan_number
                  }
                </Text>
              </View>
            ) : null}

            {downloadRevenuesData?.primary_details?.gst_number ? (
              <View style={styles.flexCenter}>
                <Text style={styles.sub_header}>GST : </Text>

                <Text style={styles.text}>
                  {downloadRevenuesData?.primary_details?.gst_number}
                </Text>
              </View>
            ) : null}

            {downloadRevenuesData?.primary_details?.business_address_details
              ?.mobile ? (
              <View style={styles.flexCenter}>
                <Text style={styles.sub_header}>Mobile No : </Text>
                <Text style={styles.text}>
                  {
                    downloadRevenuesData?.primary_details
                      ?.business_address_details?.mobile
                  }
                </Text>
              </View>
            ) : null}
            {downloadRevenuesData?.primary_details?.business_address_details
              ?.pan ? (
              <View style={styles.flexCenter}>
                <Text style={styles.sub_header}>Pan : </Text>
                <Text style={styles.text}>
                  {
                    downloadRevenuesData?.primary_details
                      ?.business_address_details?.pan
                  }
                </Text>
              </View>
            ) : null}

            {downloadRevenuesData?.primary_details?.business_address_details
              ?.email ? (
              <View style={styles.flexCenter}>
                <Text style={styles.sub_header}>Email : </Text>
                <Text style={styles.text}>
                  {
                    downloadRevenuesData?.primary_details
                      ?.business_address_details?.email
                  }
                </Text>
              </View>
            ) : null}
            {downloadRevenuesData?.primary_details?.website ? (
              <View style={styles.flexCenter}>
                <Text style={styles.sub_header}>Website : </Text>
                <Text style={styles.text}>
                  {downloadRevenuesData?.primary_details?.website}
                </Text>
              </View>
            ) : null}

            {downloadRevenuesData?.primary_details?.place_of_supply?.label?.split(
              "-"
            )[0]?.length ? (
              <Text style={{ ...styles.flexCenter, marginTop: "10px" }}>
                <Text style={styles.sub_header}>State/UT Code: </Text>
                <Text style={styles.text}>
                  {
                    downloadRevenuesData?.primary_details?.place_of_supply?.label?.split(
                      "-"
                    )[0]
                  }
                </Text>
              </Text>
            ) : null}

            {downloadRevenuesData?.primary_details?.place_of_supply?.value ? (
              <Text style={styles.flexCenter}>
                <Text style={styles.sub_header}>Place of supply : </Text>
                <Text style={styles.text}>
                  {
                    downloadRevenuesData?.primary_details?.place_of_supply
                      ?.value
                  }
                </Text>
              </Text>
            ) : null}

            {downloadRevenuesData?.primary_details?.voucher_invoice_number ? (
              <Text style={styles.flexCenter}>
                <Text style={styles.sub_header}>{renderDocumentType(downloadRevenuesData?.primary_details?.document_type?.label)} No : </Text>
                <Text style={styles.text}>
                  {
                    downloadRevenuesData?.primary_details
                      ?.voucher_invoice_number
                  }
                </Text>
              </Text>
            ) : null}

            {downloadRevenuesData?.primary_details?.voucher_invoice_date ? (
              <Text style={styles.flexCenter}>
                <Text style={styles.sub_header}>{renderDocumentType(downloadRevenuesData?.primary_details?.document_type?.label)} Date : </Text>

                <Text style={styles.text}>
                  {formatDate(
                    downloadRevenuesData?.primary_details?.voucher_invoice_date
                  )}
                </Text>
              </Text>
            ) : null}
          </View>
        </View>
        <View
          style={{
            textAlign: "left",
            minWidth: "25%",
            maxWidth: "25%",
            // marginTop: "5px",
          }}
        >
          {downloadRevenuesData?.primary_details?.ship_to_address ? (
            <Text style={{ ...styles.sub_header, color: "#dd4433" }}>
              Shipping Address :
            </Text>
          ) : null}
          {downloadRevenuesData?.primary_details?.ship_to_name?.legal_name ? (
            <Text style={{ ...styles.text, paddingVertical: "2px" }}>
              {downloadRevenuesData?.primary_details?.ship_to_name?.legal_name}
            </Text>
          ) : null}
          {downloadRevenuesData?.primary_details?.ship_to_address ? (
            <View>
              <Text style={styles.text}>
                {downloadRevenuesData?.primary_details?.ship_to_address}
              </Text>
            </View>
          ) : null}
          {downloadRevenuesData?.primary_details?.ship_to_gst ? (
            <View>
              <Text style={styles.text}>
                {downloadRevenuesData?.primary_details?.ship_to_gst}
              </Text>
            </View>
          ) : null}

          {downloadRevenuesData?.primary_details?.due_date ? (
            <Text style={styles.flexCenter}>
              <Text style={styles.sub_header}>Due Date : </Text>

              <Text style={styles.text}>
                {formatDate(downloadRevenuesData?.primary_details?.due_date)}
              </Text>
            </Text>
          ) : null}
        </View>
        {/* ////right side */}
        <View>
          <View
            style={{
              // alignItems: "flex-end",
              textAlign: "left",
              minWidth: "25%",
              maxWidth: "25%",
              // marginTop: "15px",
            }}
          >
            <Text style={{ ...styles.sub_header, color: "#dd4433" }}>
              Billing Address :{" "}
            </Text>
            {downloadRevenuesData?.primary_details?.supplier_name
              ?.legal_name ? (
              <Text style={{ ...styles.text, paddingVertical: "2px" }}>
                {
                  downloadRevenuesData?.primary_details?.supplier_name
                    ?.legal_name
                }
              </Text>
            ) : null}

            {downloadRevenuesData?.primary_details?.supplier_address1 ||
              downloadRevenuesData?.primary_details?.supplier_address2 ? (
              <Text style={styles.text}>
                <Text>
                  {(downloadRevenuesData?.primary_details?.supplier_address1 ? downloadRevenuesData?.primary_details?.supplier_address1 : "") +
                    " " +
                    (downloadRevenuesData?.primary_details?.supplier_address2 ? downloadRevenuesData?.primary_details?.supplier_address2 : "")}
                </Text>
              </Text>
            ) : null}

            {downloadRevenuesData?.primary_details?.supplier_gstn ? (
              <Text style={styles.flexCenter}>
                <Text style={styles.sub_header}>GST : </Text>
                <Text style={styles.text}>
                  {downloadRevenuesData?.primary_details?.supplier_gstn}
                </Text>
              </Text>
            ) : null}

            {downloadRevenuesData?.primary_details?.customer_supplier_details
              ?.pan_number ? (
              <Text style={styles.flexCenter}>
                <Text style={styles.sub_header}>PAN : </Text>
                <Text style={styles.text}>
                  {
                    downloadRevenuesData?.primary_details
                      ?.customer_supplier_details?.pan_number
                  }
                </Text>
              </Text>
            ) : null}

            {downloadRevenuesData?.primary_details?.customer_supplier_details
              ?.email ? (
              <Text style={styles.flexCenter}>
                <Text style={styles.sub_header}>Email : </Text>
                <Text style={styles.text}>
                  {
                    downloadRevenuesData?.primary_details
                      ?.customer_supplier_details?.email
                  }
                </Text>
              </Text>
            ) : null}

            {downloadRevenuesData?.primary_details?.customer_supplier_details
              ?.mobile ? (
              <Text style={styles.flexCenter}>
                <Text style={styles.sub_header}>Mobile : </Text>
                <Text style={styles.text}>
                  {
                    downloadRevenuesData?.primary_details
                      ?.customer_supplier_details?.mobile
                  }
                </Text>
              </Text>
            ) : null}
            {/* ////2nd */}
          </View>

        </View>
      </View>

      {/* third column  */}
      <View style={{ ...styles.sub_header_1 }}>{/* /////right side */}</View>
    </View>
  );
};

export default PurchaseOrderBillFromAndLogo;
